module.exports = __webpack_public_path__ + "static/feature-event-b59bf74e9f36d41b53266b4b8dbc8f4f.jpg";